import { Spu } from '@/api/finance/trading/product/spu';
import { fenToYuan } from './price';

export const processProductIncome = (spu: Spu) => {
  spu.price = fenToYuan(spu.price)
  spu.dailyIncome = fenToYuan(spu.dailyIncome);
  spu.dailyReturnRate = parseFloat((spu.dailyIncome * 100 / spu.price).toFixed(2));
  spu.totalIncome = spu.dailyIncome * spu.totalPeriod;
  spu.totalReturnRate = parseFloat((spu.totalIncome * 100 / spu.price).toFixed(2));
}